<template>
  <d-container fluid class="main-content-container px-4">
    <d-row no-gutters class="page-header py-4">
      <d-col col class="text-center text-sm-left mb-4 mb-sm-0">
        <span class="text-uppercase page-subtitle d-block">
          {{ $t('numerex.edit.subtitle') }}
        </span>
        <h3 class="page-title d-inline">{{ $t('numerex.edit.title') }}</h3>
        <router-link
          class="btn btn-success text-white float-right"
          :to="{ name: 'admin-numerex-new' }"
        >
          {{ $t('numerex.edit.button.add') }}
        </router-link>
      </d-col>
    </d-row>
    <numerex-page />
  </d-container>
</template>

<script>
import { mapActions } from 'vuex';
import NumerexPage from '../components/NumerexPage.vue';

export default {
  name: 'numerex-edit',
  components: {
    NumerexPage,
  },
  methods: {
    ...mapActions(['getNumerex']),
  },
  mounted() {
    if (this.$route.params.puzzleId) {
      this.getNumerex(this.$route.params.puzzleId);
    }
  },
};
</script>
